/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Success_Sendanother1Inputs */

const he_contact_success_sendanother1 = /** @type {(inputs: Contact_Success_Sendanother1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שלח הודעה נוספת`)
};

const en_contact_success_sendanother1 = /** @type {(inputs: Contact_Success_Sendanother1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send Another Message`)
};

/**
* | output |
* | --- |
* | "Send Another Message" |
*
* @param {Contact_Success_Sendanother1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const contact_success_sendanother1 = /** @type {((inputs?: Contact_Success_Sendanother1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Success_Sendanother1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_contact_success_sendanother1(inputs)
	return en_contact_success_sendanother1(inputs)
});
export { contact_success_sendanother1 as "contact_success_sendAnother" }